import { render } from "./SzWorkFlow.vue?vue&type=template&id=56432c10&scoped=true"
import script from "./SzWorkFlow.vue?vue&type=script&lang=ts"
export * from "./SzWorkFlow.vue?vue&type=script&lang=ts"

import "./SzWorkFlow.vue?vue&type=style&index=0&id=56432c10&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-56432c10"

export default script